import { IconProps } from '.';
const PaletteIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      className={customClasses}
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4011 6.80664C12.8696 6.80664 6.75 12.9549 6.75 20.5566C6.75 28.1341 12.8305 34.2674 20.3289 34.3065C20.3294 34.3064 20.3297 34.3064 20.3299 34.3064C20.3443 34.3059 20.3638 34.3053 20.3886 34.3044C20.2008 34.0394 20.029 33.7628 19.8756 33.4789C19.3135 32.4386 18.9481 31.2042 19.0296 29.974C19.1138 28.7032 19.679 27.471 20.8942 26.5911C22.069 25.7404 23.7287 25.3066 25.8648 25.3066C27.3115 25.3066 29.1835 25.1774 30.7888 24.4716C32.3233 23.7969 33.6216 22.6004 34.0761 20.3131C34.7672 16.8344 33.3398 13.4961 30.6729 10.963C27.9981 8.42237 24.1795 6.80664 20.4011 6.80664ZM20.3641 36.8066C20.3782 36.8067 20.3909 36.8067 20.3975 36.8066L20.4011 36.8066C20.4401 36.8066 20.4788 36.8048 20.5169 36.8013C20.5433 36.8003 20.5737 36.7991 20.6072 36.7976C20.7968 36.7891 21.0989 36.7721 21.4353 36.7376C21.765 36.7037 22.1613 36.6497 22.5284 36.5598C22.7121 36.5149 22.9148 36.4546 23.1102 36.3711C23.292 36.2934 23.5485 36.162 23.7714 35.9376C24.0343 35.6729 24.1653 35.3046 24.1285 34.9333C24.0917 34.562 23.8909 34.2266 23.5811 34.0187C23.0281 33.6476 22.4744 33.0296 22.0751 32.2906C21.6748 31.5497 21.4814 30.7841 21.5241 30.1392C21.5642 29.5351 21.8061 29.0173 22.3604 28.616C22.9551 28.1853 24.0273 27.8066 25.8648 27.8066C27.3983 27.8066 29.6994 27.6815 31.795 26.7601C33.9614 25.8076 35.8916 24.0041 36.5281 20.8002C37.4264 16.2789 35.5181 12.1172 32.3946 9.15032C29.2789 6.19091 24.8522 4.30664 20.4011 4.30664C11.4733 4.30664 4.25 11.5898 4.25 20.5566C4.25 29.5111 11.4534 36.7865 20.3641 36.8066ZM22.1321 34.0703C22.1371 34.0676 22.1398 34.0664 22.1398 34.0666C22.1398 34.0667 22.1373 34.068 22.1321 34.0703Z"
        fill={color}
      />
      <path
        d="M10.5 18.0566C10.5 19.4373 11.6193 20.5566 13 20.5566C14.3807 20.5566 15.5 19.4373 15.5 18.0566C15.5 16.6759 14.3807 15.5566 13 15.5566C11.6193 15.5566 10.5 16.6759 10.5 18.0566Z"
        fill={color}
      />
      <path
        d="M25.5 18.0566C25.5 19.4373 26.6193 20.5566 28 20.5566C29.3807 20.5566 30.5 19.4373 30.5 18.0566C30.5 16.6759 29.3807 15.5566 28 15.5566C26.6193 15.5566 25.5 16.6759 25.5 18.0566Z"
        fill={color}
      />
      <path
        d="M18 13.0566C18 14.4374 19.1193 15.5566 20.5 15.5566C21.8807 15.5566 23 14.4374 23 13.0566C23 11.6759 21.8807 10.5566 20.5 10.5566C19.1193 10.5566 18 11.6759 18 13.0566Z"
        fill={color}
      />
    </svg>
  );
};

export default PaletteIcon;
